import * as React from "react"
import { Container } from 'react-bootstrap'
import { Link } from 'gatsby';
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import 'bootstrap/dist/css/bootstrap.min.css'

const IndexPage = ({location}) => (
  <Layout location={location}>
    <Seo title="Introduction" />
    <Container>
    <h1>Singapore Places of Worship 新加坡多元宗教之美</h1>
    <p>
      <StaticImage layout="fullWidth" src="../images/banner.jpg" alt="Banner" />
    </p>
    <p>
      This website presents a collection of mixed media artwork of
      places of worship by a local artist,&nbsp;
      <Link to="/artist-biography">
        Dr Ho Chee Lick
      </Link>.
      Plotted on an <Link to="/map">interactive map</Link>, the drawings illustrate Singapore's multi-religious
      landscape. For each drawing, we list the names, address, year established, date of sketch
      as well as relevant literature and websites, if any. An <Link to="/data-index">index</Link> of drawings has also been compiled.
    </p>

    <p>
      In total, there are 380 drawings of predominantly&nbsp;
      <Link to="/data-index/chinese-temples">
        Chinese shrines
      </Link>
      &nbsp;of Buddhism, Taoism, popular religion and sectarian religions from antiquity to contemporary times,&nbsp;
      <Link to="/data-index/churches">
        Churches
      </Link>
      ,&nbsp;
      <Link to="/data-index/hindu-temples">
        Hindu temples
      </Link>
      ,&nbsp;
      <Link to="/data-index/islamic-mosques">
        Islamic mosques
      </Link>
      ,&nbsp;
      <Link to="/data-index/sikh-temples">
        Sikh temples
      </Link>
      , and&nbsp;
      <Link to="/data-index/other-temples">
        others
      </Link>
      . The data was compiled in 2015 and 2016. This website was revamped in 2023.
    </p>

    <p>
      <Link to="/map">
        <StaticImage layout="fullWidth" src="../images/map.png" alt="Map" />
      </Link>
    </p>

    <p>
      本网站展示新加坡画家
      <Link to="/artist-biography">
        何自力博士
      </Link>
      所绘制的蜡笔水彩混合系列画作。各画作通过<Link to="/map">互动地图</Link>，展现新加坡多元宗教之美。本网站除了列出各画作的庙宇或宗教场所名称、地址、创立年份以及画作创作日期，也提供与庙宇相关的馆藏图书和链接。此外，本网站也提供各画作的
      <Link to="/data-index">
        索引
      </Link>。
    </p>
    <p>
      本网站于第一阶段（2015年）主要展示169幅
      <a href="http://libportal.nus.edu.sg/frontend/ms/sg-places-worship/chinese-temples">
        新加坡华人庙宇
      </a>
      作品。作品各具特色，涵盖本地佛教、道教及古代至当代的民间宗教信仰的庙宇。2016年3月，本项目完成第二阶段，在本网站中加入
      <Link to="/data-index/chinese-temples">
        华人庙宇
      </Link>
      以外的其他211幅画作，其中包括
      <Link to="/data-index/churches">
        基督教与天主教教堂
      </Link>、
      <Link to="/data-index/churches">
        回教堂
      </Link>、
      <Link to="/data-index/hindu-temples">
        印度庙宇
      </Link>以及
      <Link to="/data-index/sikh-temples">
        锡克庙宇
      </Link>。本网站于2023年翻新。
    </p>
    <p>
      如有反馈，欢迎<a href="mailto:askalib@nus.edu.sg">联系</a>我们。
    </p>
    </Container>

  </Layout>
)

export default IndexPage
